import { colors } from '../../variables';
import styled from 'styled-components';

const InputMessage = styled.p`
	color: ${colors.red.warningDark};
	font-size:  14px;
	margin: 0;
	margin-top: 10px;
`;

export default InputMessage;



// WEBPACK FOOTER //
// ./src/components/Common/InputMessage/InputMessage.js